import { FieldArray, Formik } from 'formik';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Button } from 'merchant-portal-components';
import { Modal } from 'merchant-portal-components';
import { LoadingBlueLarge } from 'merchant-portal-components';
import RenderOptionsList from './RenderOptionsList';

const ModalTitle = styled.div`
  display: grid;
  grid-template-columns: auto 20px;
  padding: 24px 24px 10px;
  font-size: 20px;
`;

const ModelContentWrapper = styled.div`
  width: 800px;
`;

const ButtonsWrapper = styled.div`
  text-align: right;
  padding: 20px;
  box-shadow: 0 -2px 9px 0 rgba(0, 0, 0, 0.12);
`;

const ModalBody = styled.div`
  height: 60vh;
`;

const LineDivider = styled.hr`
  margin-top: 11px;
  margin-bottom: 11px;
  border: solid 1px #ebebeb;
`;

const OptionsSortModal = ({
  sortAssignedOptions,
  productId,
  options,
  setIsSortModalOpen,
  isSortingRequested,
  formTypeName,
}) => {
  const closeOptionsSortModal = () => {
    setIsSortModalOpen(false);
  };
  return (
    <Modal borderRadius>
      <ModelContentWrapper>
        <Formik
          initialValues={{ options: options }}
          enableReinitialize={true}
        >
          {({ values, handleReset, dirty, errors, setFieldValue }) => (
            <Fragment>
              <ModalTitle>
                <div>Sort Options</div>
                <div
                  onClick={closeOptionsSortModal}
                  style={{ cursor: 'pointer', justifySelf: 'center' }}
                >
                  <i className='fa fa-times' />
                </div>
              </ModalTitle>
              <LineDivider />
              <ModalBody>
                {isSortingRequested && <LoadingBlueLarge />}
                {!isSortingRequested && (
                  <FieldArray
                    name='options'
                    render={(arrayHelpers) => (
                      <RenderOptionsList
                        arrayHelpers={arrayHelpers}
                        formTypeName={formTypeName}
                      />
                    )}
                  />
                )}
              </ModalBody>
              <ButtonsWrapper>
                <Button
                  disabled={!dirty || isSortingRequested}
                  onClick={() => {
                    sortAssignedOptions(
                      values['options'],
                      closeOptionsSortModal,
                      productId
                    );
                  }}
                >
                  Save
                </Button>
              </ButtonsWrapper>
            </Fragment>
          )}
        </Formik>
      </ModelContentWrapper>
    </Modal>
  );
};

export default OptionsSortModal;
